<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 2C12.4632 2 12.8526 2.34838 12.9038 2.80877C13.1905 5.38927 14.0376 7.29756 15.37 8.62997C16.7024 9.96238 18.6107 10.8095 21.1912 11.0962C21.6516 11.1474 22 11.5368 22 12C22 12.4632 21.6516 12.8526 21.1912 12.9038C18.6107 13.1905 16.7024 14.0376 15.37 15.37C14.0376 16.7024 13.1905 18.6107 12.9038 21.1912C12.8526 21.6516 12.4632 22 12 22C11.5368 22 11.1474 21.6516 11.0962 21.1912C10.8095 18.6107 9.96238 16.7024 8.62997 15.37C7.29756 14.0376 5.38927 13.1905 2.80877 12.9038C2.34838 12.8526 2 12.4632 2 12C2 11.5368 2.34838 11.1474 2.80877 11.0962C5.38927 10.8095 7.29756 9.96238 8.62997 8.62997C9.96238 7.29756 10.8095 5.38927 11.0962 2.80877C11.1474 2.34838 11.5368 2 12 2ZM12 6.72035C11.4982 7.95182 10.8088 9.02221 9.91548 9.91548C9.02221 10.8088 7.95182 11.4982 6.72035 12C7.95182 12.5018 9.02221 13.1912 9.91548 14.0845C10.8086 14.9776 11.4983 16.0476 12 17.2788C12.5017 16.0476 13.1914 14.9776 14.0845 14.0845C14.9776 13.1914 16.0476 12.5017 17.2788 12C16.0476 11.4983 14.9776 10.8086 14.0845 9.91548C13.1912 9.02221 12.5018 7.95182 12 6.72035Z"
      fill="currentColor"
    />
  </svg>
</template>
